export enum FamilyId {
    ACCOMMODATION = 1,
    HELMET = 30,
    SPECIAL_OFFER = 38,
    GOURMET_ACTIVITIES = 40,
    SPORT = 41,
    AMUSEMENT_PARK = 42,
    EQUIPMENT_IND = 53,
    EQUIPMENT = 54,
    EQUIPMENT_SK = 55,
    EQUIPMENT_SP = 56,
    EQUIPMENT_DS = 63,
    SKI_SCHOOL_COLLECTIVE_NL = 64,
    MULTI_ACTIVITY_PASS = 65,
    THEME_PARK = 66,
    LUGGAGE_STORAGE = 67,
    PARTNER_EVENT = 68,
    PARKING = 69,
    TOURIST_TAX = 70,
    ON_SITE_SALE = 71,
    BIKE_ACTIVITIES = 72,
    ADDITIONAL_ACCOMMODATION = 73,
    OUTDOOR_ACTIVITIES = 74,
    FAMILY_SKIPASS = 75,
    ACTIVITIES = 77,
    TRANSFERS = 78,
    SKIPASS = 3,
    HOTEL_SERVICES = 4,
    GROCERY_BASKET_DELIVERY = 5,
    YOUR_SERVICES = 7,
    TRANSPORT = 8,
    CATERING = 11,
    SKI_SCHOOL_COLLECTIVE = 12,
    SPA_WELLNESS = 13,
    EQUIPMENT_TW = 14,
    PRICE_ADJUSTMENT_PROMO = 57,
    //FLIGHT_LUGGAGE = 80,
    FLIGHT = 81,
    FLIGHT_LUGGAGE = 82,
    TRAIN = 8,
    TRAIN_SANS_COMPARTIMENT = 83,
    RestaurationBord = 84,
}


export const FAMILY_GROUP_MAP: Record<string, FamilyId[]> = {
    EQUIPMENT: [
        FamilyId.EQUIPMENT,
        FamilyId.EQUIPMENT_DS,
        FamilyId.EQUIPMENT_IND,
        FamilyId.EQUIPMENT_SK,
        FamilyId.EQUIPMENT_SP,
        FamilyId.EQUIPMENT_TW,
    ],
    SKIPASS: [
        FamilyId.SKIPASS,
        FamilyId.FAMILY_SKIPASS
    ],
    SKI_SCHOOL: [
        FamilyId.SKI_SCHOOL_COLLECTIVE,
        FamilyId.SKI_SCHOOL_COLLECTIVE_NL
    ]
}